const SESSION_KEY = 'thrive_engagement_session_id';
const LOGIN_LOGGED_KEY = 'thrive_engagement_login_logged';

function createSessionId() {
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
    return crypto.randomUUID();
  }
  return `sess_${Date.now()}_${Math.random().toString(36).slice(2, 11)}`;
}

export function getSessionId() {
  try {
    let id = sessionStorage.getItem(SESSION_KEY);
    if (!id) {
      id = createSessionId();
      sessionStorage.setItem(SESSION_KEY, id);
    }
    return id;
  } catch {
    return createSessionId();
  }
}

export function wasLoginLoggedThisSession() {
  try {
    return sessionStorage.getItem(LOGIN_LOGGED_KEY) === '1';
  } catch {
    return false;
  }
}

export function markLoginLoggedThisSession() {
  try {
    sessionStorage.setItem(LOGIN_LOGGED_KEY, '1');
  } catch {
    // ignore storage errors
  }
}

export function buildPagePath(pathname, search = '') {
  const path = String(pathname || '/');
  const query = String(search || '');
  return `${path}${query}` || '/';
}
